import gql from 'graphql-tag'

export default gql`mutation ycmdChatRoomDelete($room_id: ID!) {
    ycmdChatRoomDelete(room_id: $room_id) 
    {
        status
	  }
}`
